import { useEffect, useRef, useState } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useGetUser } from "../api/queries/useGetUser";
import { useAppContext } from "../Context/AppContext";

function AuthHandler() {
  const { accounts } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();
  const { objectId } = useAppContext();

  const [accessToken, setAccessToken] = useState<string | null>(null);
  const accessTokenRef = useRef<string | null>(null);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      setAccessToken(token);
      accessTokenRef.current = token;
    }

    const interval = setInterval(() => {
      const updatedToken = localStorage.getItem("access_token");
      if (updatedToken && updatedToken !== accessTokenRef.current) {
        setAccessToken(updatedToken);
        accessTokenRef.current = updatedToken;
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const {
    data,
    isSuccess,
    isError,
    error,
    isLoading,
  } = useGetUser({
    id: objectId || "",
    enabled: !!objectId && isAuthenticated && !!accessToken,
  });

  useEffect(() => {
    if (!accessToken || accounts.length === 0 || location.pathname !== "/" || isLoading) {
      return;
    }

    const errorMessage =
      (error as any)?.response?.data?.message || (error as any)?.response?.data;

    if (
      isError &&
      (errorMessage === "User does not exist" ||
        errorMessage?.includes("User does not exist"))
    ) {
      navigate("/register-user", { replace: true });
      return;
    }

    if (isSuccess && data) {
      const isInactive = data.user.status === "InActive";
      const stripeStatus = data.user.stripeStatus?.toLowerCase?.();
      const isCancelled = isInactive || stripeStatus === "canceled" || stripeStatus === "cancelled";
      if (isCancelled) {
        navigate("/membership-inactive", { replace: true });
      } else if (data.user.hasPaid === 1) {
        navigate("/dashboard", { replace: true });
      } else {
        navigate("/register-user", { replace: true });
      }
    }
  }, [
    accounts.length,
    location.pathname,
    isLoading,
    isError,
    error,
    isSuccess,
    data,
    navigate,
    accessToken,
  ]);

  return null;
}

export default AuthHandler;
